import { default as _91id_93NKL3vv1I03Meta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsp8wQvCtcdEMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsIrmPp8Jn9bMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsNIgHkSzfuLMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue?macro=true";
import { default as indexImAnkfSnXvMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue?macro=true";
import { default as mailboxes4z6YGs19AtMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue?macro=true";
import { default as newJkuiFjiaFmMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue?macro=true";
import { default as scheduleoiVEgU4yrvMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue?macro=true";
import { default as _91sequenceId_93yEEu6UFgQQMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue?macro=true";
import { default as indexjpVE7jvBI9Meta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue?macro=true";
import { default as newa7czOUDrCpMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as outreachHGfqscnVyOMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setup1koR40laTqMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93SSe4FQIdaeMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as index9VDuCwjqRTMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignsy4mGtL9TbGMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discoverOg5clotrDfMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexpECaBMuSNlMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensQmcVJbQMRlMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as replieshvK3jytbQQMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93BzQYjDVpxaMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allvtmCB4kvSgMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mineToXEQDrK5rMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequencesuspnJGqPvnMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountUvh501QVz4Meta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as engaged_45accountsrKTTzbW3XrMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contactscNlepEWCjHMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsD6xG7189bWMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accounts63iZyGKflOMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contacts4Sc5FgbA9yMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as imports1DDgpiFBfBMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexq52P6PY4OlMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationscKp9ZbDzrbMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxkn6NvS7LerMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsdsLc87lu6cMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationpQajyorBTqMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as repliesPapWaWiKr5Meta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingspCRq3v8bnqMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpAUaeBiKk7WMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedYW9q43lOIOMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeesnHmwlRH3PjMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openings8eTg9aFivWMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as newso8d7pRDEOBMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websites11ktPiwW4GMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signinsegeLawqZJMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupQf4W5Vb71AMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
import { default as testpEAefV18LOMeta } from "/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignsy4mGtL9TbGMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: outreachHGfqscnVyOMeta?.name,
    path: "outreach",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: _91sequenceId_93yEEu6UFgQQMeta?.name,
    path: ":sequenceId()",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue"),
    children: [
  {
    name: "campaigns-icp-outreach-sequenceId-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId",
    path: "",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-new",
    path: "new",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue")
  }
]
  },
  {
    name: "campaigns-icp-outreach",
    path: "",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingspCRq3v8bnqMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/codebuild/output/src1436797336/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue")
  }
]